import React from "react";
import { Box, Paper, Stack, Typography, Tab, Tabs } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const DisabledTab = () => {
  const [value, setValue] = React.useState(2);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Disabled tab
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor  language={"js"} value={"              <Tabs\n" +
              "                value={value}\n" +
              "                onChange={handleChange}\n" +
              "                aria-label=\"disabled tabs example\"\n" +
              "              >\n" +
              "                <Tab label=\"Active\" />\n" +
              "                <Tab label=\"Disabled\" disabled />\n" +
              "                <Tab label=\"Active\" />\n" +
              "              </Tabs>"}>
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="disabled tabs example"
              >
                <Tab label="Active" />
                <Tab label="Disabled" disabled />
                <Tab label="Active" />
              </Tabs>
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default DisabledTab;
